import { IMessageContentTypeBubble } from "../../MessagePanel";
import { MESSAGE_STATUS } from "@home-health-notify/domain";
import ImageContentItem from "./ImageContentItem";

const ImageContent = ({
  message,
  openMediaDialog,
}: IMessageContentTypeBubble) => {
  let messageData = message.getMessage();
  const openModal = () => {
    openMediaDialog?.(message);
  };
  const isPendingMessage = messageData.status === MESSAGE_STATUS.PENDING;

  return (
    <>
      {(messageData.images ?? []).map((imageMessage, i) => (
        <ImageContentItem
          key={imageMessage.url + i}
          imageUrl={imageMessage.url}
          text={imageMessage.text}
          isPendingMessage={isPendingMessage}
          onOpenModal={openModal}
        />
      ))}
    </>
  );
};

export default ImageContent;
